import { AgreementName } from '@dev-fast/types';

export class SetAgreement {
  static readonly type = '[Agreements] set field';
  constructor(
    public name: AgreementName,
    public isAgree: boolean,
  ) {}
}
